export default __webpack_public_path__ + "static/media/bee1_short.d07df572.jpg";